export default __webpack_public_path__ + "static/media/code_side2.0504fd73.png";